import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Icon} from '@drivesally/sally-ui';
import {grey} from '@drivesally/sally-ui/lib/libs/colors';

const Wrapper = styled.div`
  flex-shrink: 0;
  position: relative;
`;

const TriggerButton = styled.button`
  align-items: center;
  background: none;
  border: 1px solid ${grey};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;

  &:hover:not(:disabled) {
    background: ${grey};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  & i {
    color: #555;
    font-size: 16px;
  }
`;

const Menu = styled.div`
  background: white;
  border: 1px solid ${grey};
  border-radius: 6px;
  bottom: calc(100% + 6px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  left: 0;
  max-height: 240px;
  min-width: 220px;
  overflow-y: auto;
  position: absolute;
  z-index: 10;
`;

const MenuItem = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: block;
  padding: 8px 12px;
  text-align: left;
  width: 100%;

  &:hover {
    background: ${grey};
  }

  &:first-child {
    border-radius: 6px 6px 0 0;
  }

  &:last-child {
    border-radius: 0 0 6px 6px;
  }
`;

const ShortcutName = styled.div`
  font-size: 13px;
  font-weight: 600;
`;

const ShortcutPreview = styled.div`
  color: #777;
  font-size: 12px;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const EmptyState = styled.div`
  color: #888;
  font-size: 13px;
  padding: 12px;
`;

const CrmShortcutPicker = ({disabled, onSelect, shortcuts}) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (shortcut) => () => {
    onSelect(shortcut);
    setOpen(false);
  };

  return (
    <Wrapper>
      <TriggerButton
        type="button"
        disabled={disabled}
        onClick={() => setOpen((value) => !value)}
        title="Insert shortcut"
      >
        <Icon icon="filetext1" />
      </TriggerButton>
      {open && (
        <>
          <div
            style={{position: 'fixed', inset: 0, zIndex: 9}}
            onClick={() => setOpen(false)}
          />
          <Menu>
            {!shortcuts.length ? (
              <EmptyState>No shortcuts available</EmptyState>
            ) : (
              shortcuts.map((shortcut) => (
                <MenuItem
                  key={shortcut.id}
                  type="button"
                  onClick={handleSelect(shortcut)}
                >
                  <ShortcutName>{shortcut.name}</ShortcutName>
                  <ShortcutPreview>{shortcut.message}</ShortcutPreview>
                </MenuItem>
              ))
            )}
          </Menu>
        </>
      )}
    </Wrapper>
  );
};

CrmShortcutPicker.propTypes = {
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  shortcuts: PropTypes.array,
};

export default CrmShortcutPicker;
